import AreaFilterDefinition from '../AreaFilterDefinition';
import AttendanceFilterDefinition from '../AttendanceFilterDefinition';
import BachelorsDegreeTypeFilterDefinition from './BachelorsDegreeTypeFilterDefinition';
import BachelorsSpecialProgrammesFilterDefinition from './BachelorsSpecialProgrammesFilterDefinition';
import ContinentFilterDefinition from '../ContinentFilterDefinition';
import { CountryFilterDefinition } from '../CountryFilterDefinition';
import DisciplineFilterDefinition from '../DisciplineFilterDefinition';
import DurationFilterDefinition from '../DurationFilterDefinition';
import { EducationLevelFilterOptionValue } from '@studyportals/search-filters/server-side';
import FormatFilterDefinition from '../FormatFilterDefinition';
import { PortalDefinition } from '../PortalDefinition';
import TuitionFeeFilterDefinition from '../TuitionFeeFilterDefinition';
import OrganisationFilterDefinition from '../OrganisationFilterDefinition';
import CampaignTypeFilterDefinition from '../CampaignTypeFilterDefinition';

class BachelorsPortalDefinition extends PortalDefinition {
	public constructor() {
		super(
			[
				OrganisationFilterDefinition,
				AttendanceFilterDefinition,
				BachelorsDegreeTypeFilterDefinition,
				DisciplineFilterDefinition,
				DurationFilterDefinition,
				FormatFilterDefinition,
				TuitionFeeFilterDefinition,
				BachelorsSpecialProgrammesFilterDefinition,
				AreaFilterDefinition,
				ContinentFilterDefinition,
				CampaignTypeFilterDefinition,
				new CountryFilterDefinition(),
			],
			['30', '82', '202', '11', '56'],
			"Bachelor's degrees",
			'bachelor',
			EducationLevelFilterOptionValue.BACHELOR,
			'Bachelors',
		);
	}
}

export default new BachelorsPortalDefinition();
